var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"Contenedor debugear"},[_c('Menu',{attrs:{"areWeinHome":"true"}}),_c('SlideShowComponent'),_c('ServicesComponent'),_c('WhoweareComponent'),_c('FooterComponent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }